export default __webpack_public_path__ + "static/media/call 1.b86ab0dd.svg";